/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  /* Mobile menu: make a parent row toggle its own section.
   *
   * The mobile menu is restyled from Broadcast's "sliderule" drill-down into an inline
   * accordion (see the mobile-menu block in theme.css). <mobile-sliderule> only ever
   * OPENS on [data-sliderule-open] — the drill-down collapsed a section through the back
   * button in the panel header, and an accordion has no such header. Without this a
   * section can be opened but never closed again.
   *
   * This does NOT forward to the theme's own hideSliderule(). That method only removes
   * .is-visible from inside an 'animationend' callback, and the accordion CSS sets
   * animation:none on those rows, so the event never fires and the panel stays open.
   * Driving the two classes directly is both simpler and independent of the animation.
   *
   * data-sliderule-pane is kept in step with the number of open sections because the
   * theme keys its item fade animations off it ([data-sliderule-pane="N"] [data-animates="N"]).
   * It also gates overflow-y on the scroll container, which theme.css now forces instead.
   *
   * aria-expanded is set here as well: Broadcast initialises it to false and never
   * updates it, so on its own it reports every section as collapsed to a screen reader.
   *
   * Reference behaviour, measured at 375px: several sections may be open at once and
   * re-clicking a parent collapses only that one, so nothing here closes siblings.
   */
  var MOBILE_MAX_WIDTH = 749;

  function syncPaneLevel(pane) {
    if (!pane) return;
    var open = pane.querySelectorAll('.sliderule__panel.is-visible').length;
    pane.setAttribute('data-sliderule-pane', String(open));
  }

  document.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth > MOBILE_MAX_WIDTH) return;

      var trigger = event.target.closest('[data-sliderule-open]');
      if (!trigger) return;

      var sliderule = trigger.closest('mobile-sliderule');
      if (!sliderule || !sliderule.closest('#header-menu')) return;

      var panel = sliderule.querySelector('.sliderule__panel');
      if (!panel) return;

      var pane = trigger.closest('[data-sliderule-pane]');

      if (panel.classList.contains('is-visible')) {
        // Second click on an open section: collapse it, and keep the theme from
        // re-opening what was just closed.
        event.preventDefault();
        event.stopPropagation();
        panel.classList.remove('is-visible', 'is-hiding');
        trigger.setAttribute('aria-expanded', 'false');
        syncPaneLevel(pane);
        return;
      }

      // First click: let the theme open it, then record the state it does not record.
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        syncPaneLevel(pane);
      });
    },
    true
  );

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
